import { render } from "./file-rejection-form-success.vue?vue&type=template&id=072dee50"
import script from "./file-rejection-form-success.vue?vue&type=script&lang=js"
export * from "./file-rejection-form-success.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__